var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('offer-links-constructor',{attrs:{"offer":_vm.offer}}),_c('offer-links-table',{attrs:{"offer":_vm.offer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }